export const APP_TYPE = 'react';
export const X_VERSION = 97.1;
